<template functional>
  <div class="section-subtitle">
    <h2 class="robotoBB">
      <slot/>
    </h2>
    <div class="section-subtitle-right" v-if="$scopedSlots.right">
      <slot name="right"></slot>
    </div>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'SectionSubtitle'
};
</script>

<style lang="postcss">
.section-subtitle {
  @apply text-upVotesBlue relative;
  font-size: 25px;
  margin-top: 10px;
  .section-subtitle-right {
    @apply absolute right-1 top-0;
  }
}
</style>